import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class HotelService {

    static getHotel(item) {

        let api = `${API_BASE_URL}${API_PATHS.getHotel}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.location) params.append("location", item.location);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addHotel(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addHotel}`;
        return axiosInstance
            .post(api, data)

    }

    static editHotel(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editHotel}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteHotel(id) {
        let api = '';
        console.log("response 1 from service file")
        api = `${API_BASE_URL}${API_PATHS.deleteHotel}?id=${id}`;
        console.log("response 2 from service file")

        return axiosInstance
            .delete(api)

             console.log("response 3 from service file end ")
    }

}

export default HotelService;
